"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/SkinPreview/index.vue"));
var _SkinView = _interopRequireDefault(require("./SkinView.vue"));
var _SkinNav = _interopRequireDefault(require("./SkinNav.vue"));
var actievApi = _interopRequireWildcard(require("@/api/activityListApi"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SkinPreview: _index.default,
    SkinView: _SkinView.default,
    SkinNav: _SkinNav.default
  },
  data: function data() {
    return {
      loading: false,
      loadingText: '加载中...',
      detailInfos: {},
      submitInfos: {},
      isLoading: false
    };
  },
  mounted: function mounted() {
    var _ref = this.$route.query || {},
      id = _ref.id,
      isDraft = _ref.isDraft,
      type = _ref.type;
    this.detailInfos = {};
    // 新建页面时（无 id），将 URL 中的 type 作为初始配置传入，使 BaseSetting 自动选中对应页面类型
    if (!id && type) {
      var pageType = this.isMiniProgramCustomer() ? 2 : Number(type);
      this.detailInfos = {
        config: {
          type: pageType
        }
      };
    }
    if (!id) return;
    this.getSkinDetails(id, isDraft);
  },
  methods: {
    throttle: _throttle.default,
    isMiniProgramCustomer: function isMiniProgramCustomer() {
      try {
        var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
        return Number(JavaInfo.type) === 5;
      } catch (e) {
        return false;
      }
    },
    getSkinDetails: function getSkinDetails(id) {
      var _this = this;
      var isDraft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      actievApi.getSkinDetailApi({
        id: id,
        isDraft: isDraft
      }).then(function (res) {
        _this.detailInfos = res;
        console.log(res, 'datas');
        setTimeout(function () {
          var _this$$refs$SkinPrevi;
          (_this$$refs$SkinPrevi = _this.$refs['SkinPreviewRef']) === null || _this$$refs$SkinPrevi === void 0 ? void 0 : _this$$refs$SkinPrevi.previewSetting(res, true);
        }, 1000);
      });
    },
    closeSkin: function closeSkin() {
      this.$router.push({
        path: "/applet/pageList"
      });
    },
    saveSkin: function saveSkin(type) {
      var _this2 = this;
      this.isLoading = true;
      console.log('submitInfos', this.submitInfos);
      try {
        // Check if submitInfos is empty
        if (!this.submitInfos || Object.keys(this.submitInfos).length === 0) {
          this.$message.error('没有内容可保存，请先添加组件内容');
          return;
        }

        // 检查页面类型
        var config = this.submitInfos.config;
        var rawList = this.submitInfos.componentList;
        var componentList = Array.isArray(rawList) ? rawList : [];

        // 小程序客户仅允许保存专题页
        if (this.isMiniProgramCustomer() && config && Number(config.type) !== 2) {
          this.$message.error('小程序客户仅可选择专题页');
          return;
        }

        // 如果是权益卡包兑换页（type=4），则需要检查是否有且只有一个权益兑换按钮
        if (config && config.type === 4) {
          var rightsExchangeButtons = componentList.filter(function (item) {
            return item.showType === 14;
          });
          if (rightsExchangeButtons.length === 0) {
            this.$message.error('权益卡包兑换页必须包含一个权益兑换按钮');
            return;
          }
          if (rightsExchangeButtons.length > 1) {
            this.$message.error('权益卡包兑换页只能包含一个权益兑换按钮');
            return;
          }
        }

        // 检查是否配置了实名认证组件（showType=18）
        var hasRealNameAuth = componentList.some(function (item) {
          return item.showType === 18;
        });

        // 游客首页（type=5）不允许包含实名认证组件
        if (config && config.type === 5 && hasRealNameAuth) {
          this.$message.error('游客首页不允许包含实名认证组件');
          return;
        }
        var invalidCatePopup = componentList.find(function (item) {
          if (item.showType !== 8) return false;
          var info = item.settingInfo || {};
          return Number(info.showCatePopup) === 1 && !info.cateBgColor;
        });
        if (invalidCatePopup) {
          this.$message.error('促销列表开启类目弹框时，请选择类目背景颜色');
          this.isLoading = false;
          return;
        }

        // Create the request data with id if available
        var requestData = _objectSpread({
          type: type
        }, this.submitInfos);

        // 带上 miniAppId（来自 URL），确保新建页面能关联小程序
        if (this.$route.query.miniAppId) {
          requestData.miniAppId = this.$route.query.miniAppId;
        }

        // 如果配置了实名认证组件，在config中标记需要实名认证
        if (hasRealNameAuth && config) {
          requestData.config = _objectSpread(_objectSpread({}, config), {}, {
            needRealNameAuth: true
          });
        }

        // Make sure id is included if it exists in route query
        if (this.$route.query.id) {
          requestData.id = this.$route.query.id;
        }
        console.log('Backend request data:', requestData);
        console.log('Backend request data after transformation:', JSON.stringify(requestData));
        actievApi.saveSkins(requestData).then(function (res) {
          _this2.$message.success('操作成功');
          _this2.closeSkin();
        }).catch(function (err) {
          console.error('Save error:', err);
          _this2.$message.error(err && err.msg || '保存失败');
        }).finally(function () {
          _this2.isLoading = false;
        });
      } catch (e) {
        console.error('saveSkin error:', e);
        this.$message.error('保存失败，请检查页面配置');
        this.isLoading = false;
      }
    },
    showPreviewSkin: function showPreviewSkin() {
      var _this3 = this;
      var datas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.log(datas, 'datasdatas');
      this.submitInfos = _objectSpread({}, datas);
      this.throttle(function () {
        var _this3$$refs$SkinPrev;
        (_this3$$refs$SkinPrev = _this3.$refs['SkinPreviewRef']) === null || _this3$$refs$SkinPrev === void 0 ? void 0 : _this3$$refs$SkinPrev.previewSetting(datas, true);
      }, 500)();
    },
    addCompont: function addCompont(item) {
      var _this$$refs$SkinViewR;
      (_this$$refs$SkinViewR = this.$refs['SkinViewRef']) === null || _this$$refs$SkinViewR === void 0 ? void 0 : _this$$refs$SkinViewR.addView(item);
    }
  }
};